// Spreadsheet apps (Excel, Numbers) convert long phone numbers to scientific
// notation ("2.56706E+11") and bake it into saved CSVs. Only ~6 significant
// digits survive, so the original numbers are unrecoverable — uploads must be
// blocked with an explanation, not previewed as if they were fine.
// Mirrors RecipientParser::SPREADSHEET_MANGLED server-side.
const SCIENTIFIC_NUMBER = /^\d+(?:\.\d+)?E[+-]?\d+$/i;

export const SPREADSHEET_CORRUPTION_MESSAGE =
  "These phone numbers were corrupted by a spreadsheet app (they look like 2.56706E+11). " +
  "Re-export the file with the phone column formatted as Text — the digits cannot be " +
  "recovered from this copy.";

// True when a phone-like column carries spreadsheet-mangled values.
// header: array of column names; rows: array of cell arrays.
export function spreadsheetMangledPhones(header, rows) {
  const index = header.findIndex((name) =>
    /phone|mobile|msisdn|tel|recipient/.test(name.trim().toLowerCase()),
  );
  if (index === -1) return false;
  return rows.some((cells) =>
    SCIENTIFIC_NUMBER.test((cells[index] || "").trim()),
  );
}
